import { LittleModalCreateEdit } from '../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { FormElement, FormRender } from '../../../../../../forms/FormRenderer/types'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { valueOrDefaultValue } from '../../../../../../utils/globals/valueOrDefaultValue'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import { PaymentRelatedTypesKeys, PaymentTypeModelType, relatedTypesInversed } from '@teinor/erp/types/company/config/paymentType'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'
import { useCallback, useState } from 'react'
import { getActiveCurrencies } from '../../../../../../utils/reducers/getters'
import { BeforeSubmitHandler } from '../../../../../../forms/TwinForm/types'
import { RowData } from '../../../../../../baseComponents/TwinTable/types'

type ModalCEConfigPaymentTypeProps = ModalEditComponentProps & {}

interface PaymentTypeModelTypeExtended extends PaymentTypeModelType {
    CurrencyId: number
}

const ModalCEConfigPaymentType: React.FC<ModalCEConfigPaymentTypeProps> = ({ allRowData, userPermissions, ...rest }) => {
    const { t } = useTwinTranslation()
    const { relatedTypeSelected, handleShowCurrrencySelector, handleBeforeSubmit } = useModalCEConfigPaymentTypeLogic({ allRowData })
    const relatedTypesDict: Record<PaymentRelatedTypesKeys, TwinDictionary> = {
        0: {
            name: t('cash', 'Metálico')
        },
        1: {
            name: t('receipt', 'Recibo')
        },
        2: {
            name: t('bank_transfer', 'Transferencia bancaria')
        },
        3: {
            name: t('bank_card', 'Tarjeta bancaria')
        },
        4: {
            name: t('reposition', 'Ajuste de pago')
        },
        5: {
            name: t('voucher', 'Vale')
        },
        6: {
            name: t('shift4', 'Shift 4')
        },
        7: {
            name: ''
        }
    }
    const extraField: FormElement<keyof PaymentTypeModelTypeExtended>[] = []
    if (relatedTypeSelected === relatedTypesInversed['cash']) {
        const currencies = getActiveCurrencies()
        extraField.push({
            name: 'CurrencyId',
            label: t('currency', 'Moneda'),
            component: 'CustomSelect',
            items: currencies,
            required: true,
            value: allRowData?.extraData?.CurrencyId
        })
    }
    const fields: FormRender<PaymentTypeModelTypeExtended> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                },
                {
                    name: 'code',
                    label: t('code', 'Código'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'relatedType',
                    label: t('relatedType', 'Tipo relacionado'),
                    component: 'CustomSelect',
                    items: relatedTypesDict,
                    required: true,
                    onChange: handleShowCurrrencySelector
                },
                ...extraField,
                {
                    name: 'activeTpv',
                    label: t('activeForTpv', 'Activar para TPV'),
                    component: 'CheckboxMargin',
                },
                {
                    name: 'icon',
                    label: t('icon', 'Icono'),
                    component: 'InputIconWithMargin',
                    defaultValue: allRowData?.icon,
                    required: true,
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                }
            ]
        },
    ]

    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (
            <LittleModalCreateEdit fields={parsedFields} url={'/api/app/config/payment/paymentType/updatePaymentType'} translations={{ title: t('editPaymentType', 'Editar tipo de pago'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} beforeSubmit={handleBeforeSubmit}/>
        )
    }
    return (<LittleModalCreateEdit fields={fields} url={'/api/app/config/payment/paymentType/createPaymentType'} translations={{
        title: t('createPaymentType', 'Crear tipo de pago'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} beforeSubmit={handleBeforeSubmit}/>)
}

interface ModalCEConfigPaymentTypeLogicProps {
    allRowData: RowData | undefined
}

const useModalCEConfigPaymentTypeLogic = ({ allRowData }: ModalCEConfigPaymentTypeLogicProps) => {
    const [relatedTypeSelected, setRelatedTypeSelected] = useState<PaymentRelatedTypesKeys>(allRowData?.relatedType)

    const handleShowCurrrencySelector = useCallback((value: any) => {
        setRelatedTypeSelected(parseInt(value) as any)
    }, [setRelatedTypeSelected])

    const handleBeforeSubmit: BeforeSubmitHandler = useCallback((values: any) => {
        values['extraData'] = {}
        if (values.CurrencyId) {
            values['extraData'] = { CurrencyId: values.CurrencyId }
            delete values.CurrencyId
        }
        return true
    }, [])
    
    return { relatedTypeSelected, handleShowCurrrencySelector, handleBeforeSubmit }
}


export default ModalCEConfigPaymentType